// removed by extract-text-webpack-plugin
module.exports = {"social-flex":"_1QY1Mtv6u-zXxsbtBBbwMa","social-link":"AP0yK4g6l7Y0ZkhZbVP4e","button-group":"_3CYK4WMnXIKFasVGQTTDfg","button":"_3k2Nv3PlRxzx_pKYIv9Dgh _3z4hgu4l-VC5FW-cdBc-3C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/General/ShareSocials/ShareSocials.scss
// module id = 1165
// module chunks = 0